import { Navigate, Outlet } from 'react-router';

import { Spinner } from '../components/index.ts';
import { useAuth } from './AuthProvider.tsx';

/**
 * Shown until `/api/auth/me` answers. Intentionally almost nothing: a logo and
 * a spinner would take longer to paint than the request usually takes, and a
 * flash of branding is worse than a moment of calm.
 */
export function Splash() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-bg">
      <Spinner label="Loading ICULogbook" />
    </div>
  );
}

/** Everything behind sign-in. */
export function RequireAuth() {
  const { status } = useAuth();

  if (status === 'loading') return <Splash />;
  if (status === 'anonymous') return <Navigate to="/login" replace />;

  return <Outlet />;
}

/**
 * Sign-in and registration. A signed-in user landing here goes straight to the
 * app rather than being asked to sign in again.
 */
export function RequireAnonymous() {
  const { status } = useAuth();

  if (status === 'loading') return <Splash />;
  if (status === 'authenticated') return <Navigate to="/entries" replace />;

  return <Outlet />;
}
